import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Pagination,
  Row,
  Col,
  Input,
  Tabs,
  Button,
  Typography,
  Image,
} from "antd";
import axios from "axios";
import { SearchOutlined } from "@ant-design/icons";
import { getAnnouncementList, getAnnouncementCount } from "./ducks/actions";
import Grid from "../../atoms/Grid/";
import { popupConfirm, Popup } from "../../atoms/Popup";
import DashboardLayout from "../../molecules/DashboardLayout";
import SectionHeader from "../../molecules/SectionHeader";
import { adminService } from "../../../configs/constants";
import AddAnnouncement from "./component/AddAnnouncement";
import { s3BucketUrl } from "../../../configs/constants";
import moment from 'moment';

const { TabPane } = Tabs;
const { Title } = Typography;

const Announcement = () => {
  const [visible, setVisible] = useState(false);
  const [trigger, setTrigger] = useState(0);
  const [searchText, setSearchText] = useState();
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState()
  const [onClose, setOnClose] = useState(false);
  const [IDs, setIDs] = useState(1)

  const dispatch = useDispatch();
  const announcemnetList = useSelector((state) => state.announcement.announcementList);
  const announcemnetCount = useSelector((state) => state.announcement.announcementCount);
  const [rowLimit, setRowLimit] = useState(announcemnetList?.length);

  const reciepient = [
    { value: 'All', name: 'All' },
    { value: 'Residential', name: 'Residential' },
    { value: 'Commercial', name: 'Commercial' },
    { value: 'custom', name: 'Custom' },
    { value: 'building', name: 'Building' }
  ]

  useEffect(() => {
    // dispatch(getAnnouncementList(1, ''));
    dispatch(getAnnouncementCount());
  }, []);

  const mediaImage = (params) => {
    const staticImageURL = `${s3BucketUrl}/${params.data.media}`
    return (
      <>
        <div className="centerImage">
          <Image
            width={90}
            src={staticImageURL}
            fallback="data:image/png;base64,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"
            placeholder={
              <Image
                preview={false}
                src={staticImageURL}
                width={250}
              />
            }
          />
        </div>
      </>
    );
  }


  const arrayPush = recipientData => {
    let a = []
    recipientData.map(e => a.push(e.assetName))
    return a.join(', ');
  }

  const recipientEmail = (params) => {
    let recipientData = params.data.recipient;
    let recipientType = params.data.recipient_type;

    if (recipientType == 'asset') {
      return (
        <div>{arrayPush(recipientData)}</div>
      )
    }
    else {
      return (
        <>
          {recipientData.join(', ')}
        </>
      );
    }
  }

  const dateFormat = (params) => {
    const date = params.data?.announcement_sent_at;
    return moment(date).format("DD-MM-YYYY h:mm A");
  }
  const gridProps = {
    sortable: true,
    filter: false,
    resizable: true,
  };

  const rowID = () => {
    //setRowLimit
  }

  const columnDefs = [
    {
      headerName: "Id",
      valueGetter: `${IDs}+node.rowIndex`,
      minWidth: 40,
      maxWidth: 80,
      pinned: 'left'
    },
    { headerName: "Announcement Id", field: "announcement_uuid" },
    { headerName: "Announcement Type", field: "announcement_type" },
    { headerName: "Recipent", field: "recipient", cellRendererFramework: recipientEmail },
    { headerName: "Title", field: "announcement_title" },
    { headerName: "Media", field: "media", cellRendererFramework: mediaImage },
    { headerName: "Announcement Sent at", field: "announcement_sent_at", maxWidth: 260, cellRendererFramework: dateFormat },
  ];

  const searchField = (
    <Input
      type="text"
      onChange={(e) => onSearch(e)}
      placeholder=""
      suffix={<SearchOutlined />}
    />
  );

  const onSearch = (e) => {
    setSearchText(e.target.value);
  };

  const addFacility = () => {
    setVisible(true);
    setTrigger(0);
  };
  const popup = [
    {
      title: (
        <Title level={3} className="ag-primary mb-0">
          Add New Announcement
        </Title>
      ),
      content: (
        <AddAnnouncement
          page={page}
          onClose={onClose} setOnClose={setOnClose}
          onCancel={() => setVisible(false)}
          reciepient={reciepient.map((index) => ({
            label: index.name,
            value: index.value,
          }))}
        />
      ),
      width: 650,
    },
    {
      title: (
        <Title level={3} className="ag-primary mb-0">
          Assign a Building
        </Title>
      ),
      content: (
        <>

        </>
      ),
      width: 650,
    },
  ];

  const onCancel = () => {
    setOnClose(true)
    setVisible(false)
  }
  const popupProps = {
    closable: true,
    visibility: visible,
    title: popup[trigger].title,
    content: popup[trigger].content,
    width: popup[trigger].width,
    onCancel: () => onCancel(),
  };


  const fetchPagData = (e) => {
    if (e >= 2) {
      if (e > page) {
        setIDs(((e - 1) * 50) + 1)
        setPage(e);
      }
      else if (e < page) {
        setIDs(((e - 1) * 50) + 1)
        setPage(e);
      }
    }
    else {
      setIDs(e)
      setPage(e);
    }
    dispatch(getAnnouncementList(e, ''));
    dispatch(getAnnouncementCount(e));
  };

  const getRowHeight = params => params.node.group ? 75 : 75;

  const onFilterData = (e) => {
    setSearch(e.target.value)
  }
  useEffect(() => {
    const filterData = () => {
      setPage(1)
      dispatch(getAnnouncementList(1, search))
    }
    const debouncer = setTimeout(() => {
      filterData();
    }, 1500);
    return () => {
      clearTimeout(debouncer);
    };
  }, [search])
  return (
    <>
      <DashboardLayout>
        <SectionHeader
          heading="Announcement"
          addNewAction={addFacility}
          search={onFilterData}
        />

        <Row gutter={[24, 24]} className="heightAuto">
          <Col span={24}>
            {announcemnetList && (
              <>
                <Grid
                  data={announcemnetList.data ? announcemnetList.data : 0}
                  columns={columnDefs}
                  filterGrid={searchText}
                  pagination={false}
                  defaultSettings={gridProps}
                  getRowHeight={getRowHeight}
                />
                <Row justify="end" className="mt-1">
                  <Pagination
                    style={{ width: '100%' }}
                    className="ag-property-text-pagination"
                    current={page}
                    pageSize={50}
                    total={announcemnetCount && announcemnetCount}
                    onChange={fetchPagData}
                    showSizeChanger={false}
                    showTotal={(total, range) =>
                      `Showing ${range[1]}-${total} Announcement`
                    }
                  />
                </Row>
              </>
            )}
          </Col>
        </Row>
      </DashboardLayout>
      <Popup {...popupProps} />
    </>
  );
};

export default Announcement;
